import React from 'react'

import { DatePickerComponent, Inject, MaskedDateTime } from '@syncfusion/ej2-react-calendars'

import { getMixedProps } from './blockPublic'
import { nullDate } from '../../../utility'
import { useEventHandler, useInstData } from 'tyan/public/hooks'

const FormMonth = ({ config: { field, onChange, initValues, /* changedValues,  */defaultStyle, that } }) => {
	const { me } = useInstData()
	const { value: currentValue, name } = field
	const d = currentValue && currentValue !== nullDate && new Date(currentValue) || null
	const value = d && new Date(d.getUTCFullYear(), d.getUTCMonth(), 1)
	const handleChange = useEventHandler(({ value: inputValue }) => {
		const newValue = inputValue ? Date.UTC(inputValue.getFullYear(), inputValue.getMonth(), 1).valueOf() : nullDate
		onChange({ name, newValue: newValue, type: 'date' })
	})

	let { props: { disabled, minDate, min, maxDate, max, ...props } } = getMixedProps('_date', [defaultStyle, field])
	min = min || minDate
	max = max || maxDate
	min && (props.min = new Date(min.getFullYear(), min.getMonth(), min.getDate()))
	max && (props.max = new Date(max.getFullYear(), max.getMonth(), max.getDate()))

	return <DatePickerComponent {...props}
		openOnFocus
		start={'Year'} depth={'Year'}
		// start={'Decade'} depth={'Decade'}
		format='y/MM' enableMask maskPlaceholder={{ year: 'yyyy', month: 'mm' }}
		enabled={!disabled} value={value} change={handleChange} /* focus={handleFocus} blur={handleBlur} */ >
		<Inject services={[MaskedDateTime]} />
	</DatePickerComponent>
}

const renderMonth = config => {
	const { key } = config.field || {}
	return <FormMonth key={key} config={config} />
}

export default renderMonth